import { render, staticRenderFns } from "./FileOptions.vue?vue&type=template&id=020e8b49&"
import script from "./FileOptions.vue?vue&type=script&lang=js&"
export * from "./FileOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020e8b49')) {
      api.createRecord('020e8b49', component.options)
    } else {
      api.reload('020e8b49', component.options)
    }
    module.hot.accept("./FileOptions.vue?vue&type=template&id=020e8b49&", function () {
      api.rerender('020e8b49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/files/FileOptions.vue"
export default component.exports